import { FC, useEffect, useState } from 'react'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { SpinnerStyled } from './styled'
import { loadAnimation } from 'featureSliced/shared/utils/loadAnimation'
import { AnimationData } from 'featureSliced/shared/utils/animations'
import Lottie from 'lottie-react'

type SpinnerProps = {
  type?: 'default' | 'alternate' | 'transparent'
}

const backgroundColors = {
  light: {
    default: '#434343',
    alternate: '#fafafa',
    transparent: 'transparent',
  },
  dark: {
    default: '#434343',
    alternate: '#16161c',
    transparent: 'transparent',
  },
}

const positions = {
  default: 'static',
  alternate: 'static',
  transparent: 'absolute',
}

export const Spinner: FC<SpinnerProps> = ({ type = 'default' }) => {
  const appTheme = useMySelector((state) => state.app.interfaceStyles.appTheme)
  const [animation, setAnimation] = useState<AnimationData | null>(null)

  // useEffects
  useEffect(() => {
    loadAnimation(`loadingAnimation.json`, (error) => {
      console.error('Failed to load guide animation:', error)
    }).then(setAnimation)
  }, [])

  return (
    <SpinnerStyled
      background={backgroundColors?.[appTheme]?.[type]}
      position={positions?.[type]}
    >
      <Lottie animationData={animation} loop={true} />
      {/* <SpinnerImage src={imageSrc} height="300" width="300" alt="Loading..." /> */}
    </SpinnerStyled>
  )
}
